import React, { useContext } from "react"
import {
  accesDirectTitle,
  accesDirectDescription,
  accesDirectContainer,
  accesDirectHeader,
  editButtonTitle,
  closeButton,
} from "./acces-direct.module.scss"
import { Title } from "./acces-direct-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import RenderAccesDirect from "gatsby-theme-blank/src/components/Home/AccesDirect/RenderAccesDirect/render-acces-direct"
import { useAccesDirect } from "gatsby-theme-blank/src/components/Home/AccesDirect/acces-direct-query"
import { AccesDirectContext } from "gatsby-theme-amaryllis/src/components/acces-direct-context"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------Parent component---------------------------//

const AccesDirects = () => {
  const data = useAccesDirect()
  const accesdirectItem = data.allDirectLinkEntityDirectLinkEntity.edges
  const { isAccesDirectOpen, setIsAccesDirectOpen } =
    useContext(AccesDirectContext)

  if (accesdirectItem.length > 0) {
    return (
      <>
        <div className={accesDirectHeader} id={"acces-direct"}>
          <Title className={accesDirectTitle}>
            <EditButton
              addedClass={editButtonTitle}
              link={
                "/taxonomy/term/" +
                data.taxonomyTermTypeDeLienDirect.drupal_internal__tid +
                "/edit"
              }
            />
            {data.taxonomyTermTypeDeLienDirect?.field_label || "Accès Direct"}
          </Title>
          <button
            id={"close-direct-access"}
            className={closeButton}
            onClick={(event) => {
              if (typeof document !== `undefined`) {
                document.getElementById("open-acces-direct").focus()
                setIsAccesDirectOpen(false)
                const directAccessElement = document.querySelectorAll(
                  "#acces-direct-responsive a"
                )
                directAccessElement.forEach((element) => {
                  element.setAttribute("tabindex", "-1")
                })
              }
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                if (typeof document !== `undefined`) {
                  document.getElementById("open-acces-direct").focus()
                  const directAccessElement = document.querySelectorAll(
                    "#acces-direct-responsive a"
                  )
                  directAccessElement.forEach((element) => {
                    element.setAttribute("tabindex", "-1")
                  })
                  setIsAccesDirectOpen(false)
                }
              }
            }}
            aria-label={"Fermer l’accès direct"}
            tabIndex={isAccesDirectOpen ? "0" : -1}
          >
            <span aria-hidden={true}>X</span>
          </button>
        </div>
        {data.taxonomyTermTypeDeLienDirect.description && (
          <div className={accesDirectDescription}>
            <ContentTransformer
              content={data.taxonomyTermTypeDeLienDirect.description.processed}
            ></ContentTransformer>
          </div>
        )}
        <div className={accesDirectContainer}>
          <RenderAccesDirect accesDirectData={data} />
        </div>
      </>
    )
  }
  return null
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

//-----------------------Prop-Types---------------------------//

export default AccesDirects
